import React from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from "../../../util/IntlMessages";
import { Progress } from "reactstrap";
import coachIcon from "../../../assets/images/icons/dashboard/coach-icon.svg";
import playerIcon from "../../../assets/images/icons/dashboard/player-icon.svg";
import batterIcon from "../../../assets/images/icons/dashboard/batter-icon.svg";
import bowlerIcon from "../../../assets/images/icons/dashboard/bowler-icon.svg";
import wicketKeeperIcon from "../../../assets/images/icons/dashboard/wicket-keeper-icon.svg";
import allRounderIcon from "../../../assets/images/icons/dashboard/all-rounder-icon.svg";
import StanceBeamDoubleBarChart from '../../../components/Charts/StanceBeamDoubleBarChart';
import ContainerHeader from '../../../components/ContainerHeader'
import {
  acaDashboardCoach,
  acaDashboardPlayer,
  acaDashboardBowler,
  acaDashboardBatwk,
  acaDashboardAllr
} from '../../../actions/DashboardAction';

class Dashboard extends React.Component {
  constructor() {
    super()
    this.state = {
      bowlersStates: [{
        x: "",
        "Right Handed": "",
        "Left Handed": ""
      }],
      allrStates: [{
        x: "",
        "Right Handed": "",
        "Left Handed": ""
      }]

    }
  }

  componentDidMount() {
    const sessionToken = this.props.auth.authUser.sessionToken;
    if (this.props.acaDashboardCoachStates === null) {
      this.props.acaDashboardCoach({ sessionToken });
    }
    if (this.props.acaDashboardPlayerStates === null) {
      this.props.acaDashboardPlayer({ sessionToken });
    }
    if (this.props.acaDashboardBowlerStates === null) {
      this.props.acaDashboardBowler({ sessionToken });
    } else {
      this.updateBowlerStates(this.props.acaDashboardBowlerStates);
    }
    if (this.props.acaDashboardBatwkStates === null) {
      this.props.acaDashboardBatwk({ sessionToken });
    }
    if (this.props.acaDashboardAllrStates === null) {
      this.props.acaDashboardAllr({ sessionToken });
    } else {
      this.updateAllrStates(this.props.acaDashboardAllrStates);
    }

    // if (this.props.acaDashboardBowlerStates != null) {
    //   this.updateBowlerStates(this.props.acaDashboardBowlerStates);
    // }
    // if (this.props.acaDashboardAllrStates != null) {
    //   this.updateAllrStates(this.props.acaDashboardAllrStates);
    // }

  }

  componentDidUpdate(prevProps) {
    if (prevProps.acaDashboardBowlerStates !== this.props.acaDashboardBowlerStates) {
      this.updateBowlerStates(this.props.acaDashboardBowlerStates);
    }
    if (prevProps.acaDashboardAllrStates !== this.props.acaDashboardAllrStates) {
      this.updateAllrStates(this.props.acaDashboardAllrStates);
    }
  }

  updateBowlerStates(acaDashboardBowlerStates) {
    var localBowlersStates = []
    try {
      localBowlersStates.push(
        {
          x: "Fast",
          "Right Handed": acaDashboardBowlerStates.totalAcaPlBolRhFst,
          "Left Handed": acaDashboardBowlerStates.totalAcaPlBolLhFst
        }
      )
      localBowlersStates.push(
        {
          x: "Medium",
          "Right Handed": acaDashboardBowlerStates.totalAcaPlBolRhMed,
          "Left Handed": acaDashboardBowlerStates.totalAcaPlBolLhMed
        }
      )
      localBowlersStates.push(
        {
          x: "Spin",
          "Right Handed": acaDashboardBowlerStates.totalAcaPlBolRhSpn,
          "Left Handed": acaDashboardBowlerStates.totalAcaPlBolLhSpn
        }
      )
      this.setState({
        bowlersStates: localBowlersStates
      })
    } catch (errors) {

    }
  }

  updateAllrStates(acaDashboardAllrStates) {
    var localAllrStates = []
    try {
      localAllrStates.push(
        {
          x: "Fast",
          "Right Handed": acaDashboardAllrStates.totalAcaPlAllrRhFst,
          "Left Handed": acaDashboardAllrStates.totalAcaPlAllrLhFst
        }
      )
      localAllrStates.push(
        {
          x: "Medium",
          "Right Handed": acaDashboardAllrStates.totalAcaPlAllrRhMed,
          "Left Handed": acaDashboardAllrStates.totalAcaPlAllrLhMed
        }
      )
      localAllrStates.push(
        {
          x: "Spin",
          "Right Handed": acaDashboardAllrStates.totalAcaPlAllrRhSpn,
          "Left Handed": acaDashboardAllrStates.totalAcaPlAllrLhSpn
        }
      )
      this.setState({
        allrStates: localAllrStates
      })
    } catch (errors) {

    }
  }

  render() {
    return (
      <div className="app-wrapper">
        <div className="dashboard animated slideInUpTiny animation-duration-3">
          <ContainerHeader
            match={this.props.match}
            title={<IntlMessages id="dashboard.title" />}
          />
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="card jr-card-intra shadow text-center">
                    <div className="card-header px-3 d-flex align-items-center" style={{ minHeight: '95px' }}>
                      <div>
                        <img src={coachIcon} title="stanceBeam" alt="" />
                        <br />
                        <h3><IntlMessages id="dashboard.coaches" /></h3>
                      </div>
                      {this.props.acaDashboardCoachLoader ? (
                        <Skeleton animation="wave" variant="rect" className="ml-auto font-weight-semibold display-4" height={60} width="25%" />
                      ) : (
                          <h1 className="ml-auto font-weight-semibold display-4">{this.props.acaDashboardCoachStates != null ? this.props.acaDashboardCoachStates.totalAcaCoaches : ""}</h1>
                        )}
                    </div>
                    <div className="stack-order py-4 px-2" style={{ minHeight: '160px' }}>

                      <div className="row">
                        <div className="col-6">
                          {this.props.acaDashboardCoachLoader ? (
                            <Skeleton animation="wave" variant="rect" className="mb-3 my-1" style={{ height: 30 }} />
                          ) : (
                              <div>
                                <div className="d-flex flex-row p-0">
                                  <p className="m-0">Batting</p>
                                  <p className="ml-auto m-0">{this.props.acaDashboardCoachStates != null ? this.props.acaDashboardCoachStates.totalAcaCoachesBat : ""}</p>
                                </div>
                                <Progress className="shadow-sm mb-3 my-1" style={{ height: 6 }} color="success" value={this.props.acaDashboardCoachStates != null ? (this.props.acaDashboardCoachStates.totalAcaCoachesBat * 100 / this.props.acaDashboardCoachStates.totalAcaCoaches) : 0} />
                              </div>
                            )}

                          {this.props.acaDashboardCoachLoader ? (
                            <Skeleton animation="wave" variant="rect" className="my-1" style={{ height: 30 }} />
                          ) : (
                              <div>
                                <div className="d-flex flex-row">
                                  <p className="m-0">Male</p>
                                  <p className="ml-auto m-0">{this.props.acaDashboardCoachStates != null ? this.props.acaDashboardCoachStates.totalAcaCoachesMale : ""}</p>
                                </div>
                                <Progress className="shadow-sm my-1" style={{ height: 6 }} color="default" value={this.props.acaDashboardCoachStates != null ? (this.props.acaDashboardCoachStates.totalAcaCoachesMale * 100 / this.props.acaDashboardCoachStates.totalAcaCoaches) : 0} />
                              </div>
                            )}
                        </div>
                        <div className="col-6">
                          {this.props.acaDashboardCoachLoader ? (
                            <Skeleton animation="wave" variant="rect" className="mb-3 my-1" style={{ height: 30 }} />
                          ) : (
                              <div>
                                <div className="d-flex flex-row p-0">
                                  <p className="m-0">Bowling</p>
                                  <p className="ml-auto m-0">{this.props.acaDashboardCoachStates != null ? this.props.acaDashboardCoachStates.totalAcaCoachesBol : ""}</p>
                                </div>
                                <Progress className="shadow-sm mb-3 my-1" style={{ height: 6 }} color="info" value={this.props.acaDashboardCoachStates != null ? (this.props.acaDashboardCoachStates.totalAcaCoachesBol * 100 / this.props.acaDashboardCoachStates.totalAcaCoaches) : 0} />
                              </div>
                            )}

                          {this.props.acaDashboardCoachLoader ? (
                            <Skeleton animation="wave" variant="rect" className="my-1" style={{ height: 30 }} />
                          ) : (
                              <div>
                                <div className="d-flex flex-row">
                                  <p className="m-0">Female </p>
                                  <p className="ml-auto m-0">{this.props.acaDashboardCoachStates != null ? this.props.acaDashboardCoachStates.totalAcaCoachesFemale : ""}</p>
                                </div>
                                <Progress className="shadow-sm my-1" style={{ height: 6 }} color="warning" value={this.props.acaDashboardCoachStates != null ? (this.props.acaDashboardCoachStates.totalAcaCoachesFemale * 100 / this.props.acaDashboardCoachStates.totalAcaCoaches) : 0} />
                              </div>
                            )}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="card jr-card-intra shadow text-center">
                    <div className="card-header px-3 d-flex align-items-center" style={{ minHeight: '95px' }}>
                      <div>
                        <img src={playerIcon} title="stanceBeam" alt="" />
                        <br />
                        <h3><IntlMessages id="dashboard.players" /></h3>
                      </div>
                      {this.props.acaDashboardPlayerLoader ? (
                        <Skeleton animation="wave" variant="rect" className="ml-auto font-weight-semibold display-4" height={60} width="25%" />
                      ) : (
                          <h1 className="ml-auto font-weight-semibold display-4">{this.props.acaDashboardPlayerStates != null ? this.props.acaDashboardPlayerStates.totalAcaPl : ""}</h1>
                        )}
                    </div>
                    <div className="stack-order py-4 px-2" style={{ minHeight: '160px' }}>
                      <div className="row">
                        <div className="col-6">
                          {this.props.acaDashboardPlayerLoader ? (
                            <Skeleton animation="wave" variant="rect" className="mb-3 my-1" style={{ height: 30 }} />
                          ) : (
                              <div>
                                <div className="d-flex flex-row p-0">
                                  <p className="m-0"><IntlMessages id="dashboard.batters" /></p>
                                  <p className="ml-auto m-0">{this.props.acaDashboardPlayerStates != null ? this.props.acaDashboardPlayerStates.totalAcaPlBat : ""}</p>
                                </div>
                                <Progress className="shadow-sm mb-3 my-1" style={{ height: 6 }} color="success" value={this.props.acaDashboardPlayerStates != null ? (this.props.acaDashboardPlayerStates.totalAcaPlBat * 100 / this.props.acaDashboardPlayerStates.totalAcaPl) : 0} />
                              </div>
                            )}
                          {this.props.acaDashboardPlayerLoader ? (
                            <Skeleton animation="wave" variant="rect" className="my-1" style={{ height: 30 }} />
                          ) : (
                              <div>
                                <div className="d-flex flex-row">
                                  <p className="m-0">Male</p>
                                  <p className="ml-auto m-0">{this.props.acaDashboardPlayerStates != null ? this.props.acaDashboardPlayerStates.totalAcaPlMale : ""}</p>
                                </div>
                                <Progress className="shadow-sm my-1" style={{ height: 6 }} color="default" value={this.props.acaDashboardPlayerStates != null ? (this.props.acaDashboardPlayerStates.totalAcaPlMale * 100 / this.props.acaDashboardPlayerStates.totalAcaPl) : 0} />
                              </div>
                            )}
                        </div>
                        <div className="col-6">
                          {this.props.acaDashboardPlayerLoader ? (
                            <Skeleton animation="wave" variant="rect" className="mb-3 my-1" style={{ height: 30 }} />
                          ) : (
                              <div>
                                <div className="d-flex flex-row p-0">
                                  <p className="m-0"><IntlMessages id="dashboard.bowlers" /></p>
                                  <p className="ml-auto m-0">{this.props.acaDashboardPlayerStates != null ? this.props.acaDashboardPlayerStates.totalAcaPlBol : ""}</p>
                                </div>
                                <Progress className="shadow-sm mb-3 my-1" style={{ height: 6 }} color="info" value={this.props.acaDashboardPlayerStates != null ? (this.props.acaDashboardPlayerStates.totalAcaPlBol * 100 / this.props.acaDashboardPlayerStates.totalAcaPl) : 0} />
                              </div>
                            )}
                          {this.props.acaDashboardPlayerLoader ? (
                            <Skeleton animation="wave" variant="rect" className="my-1" style={{ height: 30 }} />
                          ) : (
                              <div>
                                <div className="d-flex flex-row">
                                  <p className="m-0">Female </p>
                                  <p className="ml-auto m-0">{this.props.acaDashboardPlayerStates != null ? this.props.acaDashboardPlayerStates.totalAcaPlFemale : ""}</p>
                                </div>
                                <Progress className="shadow-sm my-1" style={{ height: 6 }} color="warning" value={this.props.acaDashboardPlayerStates != null ? (this.props.acaDashboardPlayerStates.totalAcaPlFemale * 100 / this.props.acaDashboardPlayerStates.totalAcaPl) : 0} />
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="card jr-card-intra shadow text-center">
                    <div className="card-header px-3 d-flex align-items-center" style={{ minHeight: '95px' }}>
                      <div>
                        <img src={batterIcon} title="stanceBeam" alt="" />
                        <br />
                        <h3><IntlMessages id="dashboard.batters" /></h3>
                      </div>
                      {this.props.acaDashboardBatwkLoader ? (
                        <Skeleton animation="wave" variant="rect" className="ml-auto font-weight-semibold display-4" height={60} width="25%" />
                      ) : (
                          <h1 className="ml-auto font-weight-semibold display-4">{this.props.acaDashboardBatwkStates != null ? this.props.acaDashboardBatwkStates.totalAcaPlBat : ""}</h1>
                        )}
                    </div>
                    <div className="stack-order py-4 px-2" style={{ minHeight: '160px' }}>
                      {this.props.acaDashboardBatwkLoader ? (
                        <Skeleton animation="wave" variant="rect" className="mb-3 my-1" style={{ height: 30 }} />
                      ) : (
                          <div>
                            <div className="d-flex flex-row p-0">
                              <p className="m-0">Right Handed Bat</p>
                              <p className="ml-auto m-0">{this.props.acaDashboardBatwkStates != null ? this.props.acaDashboardBatwkStates.totalAcaPlBatRh : ""}</p>
                            </div>
                            <Progress className="shadow-sm mb-3 my-1" style={{ height: 6 }} color="success" value={this.props.acaDashboardBatwkStates != null ? (this.props.acaDashboardBatwkStates.totalAcaPlBatRh * 100 / this.props.acaDashboardBatwkStates.totalAcaPlBat) : 0} />
                          </div>
                        )}
                      {this.props.acaDashboardBatwkLoader ? (
                        <Skeleton animation="wave" variant="rect" className="my-1" style={{ height: 30 }} />
                      ) : (
                          <div>
                            <div className="d-flex flex-row">
                              <p className="m-0">Left Handed Bat</p>
                              <p className="ml-auto m-0">{this.props.acaDashboardBatwkStates != null ? this.props.acaDashboardBatwkStates.totalAcaPlBatLh : ""}</p>
                            </div>
                            <Progress className="shadow-sm my-1" style={{ height: 6 }} color="default" value={this.props.acaDashboardBatwkStates != null ? (this.props.acaDashboardBatwkStates.totalAcaPlBatLh * 100 / this.props.acaDashboardBatwkStates.totalAcaPlBat) : 0} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 col-12">
                  <div className="card jr-card-intra shadow text-center">
                    <div className="card-header px-3 d-flex align-items-center" style={{ minHeight: '95px' }}>
                      <div>
                        <img src={wicketKeeperIcon} title="stanceBeam" alt="" />
                        <br />
                        <h3><IntlMessages id="dashboard.wicketkeeper" /></h3>
                      </div>
                      {this.props.acaDashboardBatwkLoader ? (
                        <Skeleton animation="wave" variant="rect" className="ml-auto font-weight-semibold display-4" height={60} width="25%" />
                      ) : (
                          <h1 className="ml-auto font-weight-semibold display-4">{this.props.acaDashboardBatwkStates != null ? this.props.acaDashboardBatwkStates.totalAcaPlWk : ""}</h1>
                        )}
                    </div>
                    <div className="stack-order py-4 px-2" style={{ minHeight: '160px' }}>
                      {this.props.acaDashboardBatwkLoader ? (
                        <Skeleton animation="wave" variant="rect" className="mb-3 my-1" style={{ height: 30 }} />
                      ) : (
                          <div>
                            <div className="d-flex flex-row p-0">
                              <p className="m-0">Right Handed Bat</p>
                              <p className="ml-auto m-0">{this.props.acaDashboardBatwkStates != null ? this.props.acaDashboardBatwkStates.totalAcaPlWkRh : ""}</p>
                            </div>
                            <Progress className="shadow-sm mb-3 my-1" style={{ height: 6 }} color="success" value={this.props.acaDashboardBatwkStates != null ? (this.props.acaDashboardBatwkStates.totalAcaPlWkRh * 100 / this.props.acaDashboardBatwkStates.totalAcaPlWk) : 0} />
                          </div>
                        )}
                      {this.props.acaDashboardBatwkLoader ? (
                        <Skeleton animation="wave" variant="rect" className="my-1" style={{ height: 30 }} />
                      ) : (
                          <div>
                            <div className="d-flex flex-row">
                              <p className="m-0">Left Handed Bat</p>
                              <p className="ml-auto m-0">{this.props.acaDashboardBatwkStates != null ? this.props.acaDashboardBatwkStates.totalAcaPlWkLh : ""}</p>
                            </div>
                            <Progress className="shadow-sm my-1" style={{ height: 6 }} color="default" value={this.props.acaDashboardBatwkStates != null ? (this.props.acaDashboardBatwkStates.totalAcaPlWkLh * 100 / this.props.acaDashboardBatwkStates.totalAcaPlWk) : 0} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="row">
                <div className="col-lg-5 col-12">
                  <div className="card jr-card-intra shadow text-center">
                    <div className="card-header px-3 d-flex align-items-center" style={{ minHeight: '95px' }}>
                      <div>
                        <img src={bowlerIcon} title="stanceBeam" alt="" />
                        <br />
                        <h3><IntlMessages id="dashboard.bowlers" /></h3>
                      </div>
                      {this.props.acaDashboardBowlerLoader ? (
                        <Skeleton animation="wave" variant="rect" className="ml-auto font-weight-semibold display-4" height={60} width="70px" />
                      ) : (
                          <h1 className="ml-auto font-weight-semibold display-4">{this.props.acaDashboardBowlerStates != null ? this.props.acaDashboardBowlerStates.totalAcaPlBol : ""}</h1>
                        )}
                    </div>

                    <div className="stack-order py-4 px-2" style={{ minHeight: '160px' }}>
                      {this.props.acaDashboardBowlerLoader ? (
                        <Skeleton animation="wave" variant="rect" style={{ height: 200 }} />
                      ) : (
                          <StanceBeamDoubleBarChart chartData={this.state.bowlersStates} firstBarColor="#ffc658" secondBarColor="#6399A3" />
                        )}
                    </div>

                  </div>
                </div>
                <div className="col-lg-7 col-12">
                  <div className="card jr-card-intra shadow text-center">
                    <div className="card-header px-3 d-flex align-items-center" style={{ minHeight: '95px' }}>
                      <div>
                        <img src={allRounderIcon} title="stanceBeam" alt="" />
                        <br />
                        <h3><IntlMessages id="dashboard.allrounders" /></h3>
                      </div>
                      {this.props.acaDashboardAllrLoader ? (
                        <Skeleton animation="wave" variant="rect" className="ml-auto font-weight-semibold display-4" height={60} width="70px" />
                      ) : (
                          <h1 className="ml-auto font-weight-semibold display-4">{this.props.acaDashboardAllrStates != null ? this.props.acaDashboardAllrStates.totalAcaPlAllr : ""}</h1>
                        )}
                    </div>
                    <div className="stack-order py-4 px-2" style={{ minHeight: '160px' }}>
                      <div className="row">
                        <div className="col-md-8 col-12">
                          {this.props.acaDashboardAllrLoader ? (
                            <Skeleton animation="wave" variant="rect" style={{ height: 200 }} />
                          ) : (
                              <StanceBeamDoubleBarChart chartData={this.state.allrStates} firstBarColor="#ffc658" secondBarColor="#6399A3" />
                            )}
                        </div>
                        <div className="col-md-4 col-12">
                          {this.props.acaDashboardAllrLoader ? (
                            <Skeleton animation="wave" variant="rect" className="pt-4" style={{ height: 30 }} />
                          ) : (
                              <div>
                                <div className="d-flex flex-row pt-4 p-0">
                                  <p className="m-0">Right Handed Bat</p>
                                  <p className="ml-auto m-0">{this.props.acaDashboardAllrStates != null ? this.props.acaDashboardAllrStates.totalAcaPlAllrRhBat : ""}</p>
                                </div>
                                <Progress className="shadow-sm mb-3 my-1" style={{ height: 6 }} color="success" value={this.props.acaDashboardAllrStates != null ? (this.props.acaDashboardAllrStates.totalAcaPlAllrRhBat * 100 / this.props.acaDashboardAllrStates.totalAcaPlAllr) : 0} />
                              </div>
                            )}
                          {this.props.acaDashboardAllrLoader ? (
                            <Skeleton animation="wave" variant="rect" style={{ height: 40, marginTop: 5 }} />
                          ) : (
                              <div>
                                <div className="d-flex flex-row">
                                  <p className="m-0">Left Handed Bat</p>
                                  <p className="ml-auto m-0">{this.props.acaDashboardAllrStates != null ? this.props.acaDashboardAllrStates.totalAcaPlAllrLhBat : ""}</p>
                                </div>
                                <Progress className="shadow-sm my-1" style={{ height: 6 }} color="default" value={this.props.acaDashboardAllrStates != null ? (this.props.acaDashboardAllrStates.totalAcaPlAllrLhBat * 100 / this.props.acaDashboardAllrStates.totalAcaPlAllr) : 0} />
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = ({ settings, dashboard, auth }) => {
  const { width, drawerType, navigationStyle, horizontalNavPosition } = settings;
  const { acaDashboardCoachStates, acaDashboardPlayerStates, acaDashboardBowlerStates, acaDashboardBatwkStates, acaDashboardAllrStates, acaDashboardCoachLoader, acaDashboardPlayerLoader, acaDashboardBowlerLoader, acaDashboardBatwkLoader, acaDashboardAllrLoader } = dashboard;
  return { width, drawerType, navigationStyle, horizontalNavPosition, auth, acaDashboardCoachStates, acaDashboardPlayerStates, acaDashboardBowlerStates, acaDashboardBatwkStates, acaDashboardAllrStates, acaDashboardCoachLoader, acaDashboardPlayerLoader, acaDashboardBowlerLoader, acaDashboardBatwkLoader, acaDashboardAllrLoader }
}
export default withRouter(connect(mapStateToProps, {
  acaDashboardCoach,
  acaDashboardPlayer,
  acaDashboardBowler,
  acaDashboardBatwk,
  acaDashboardAllr
})(Dashboard));
